export const DEFAULT_MAX_LENGTH = 250;
export const OTHER_OPTION_ID = '__other__';
export const maxCharOfComparisonTable = 100;
export const IMAGE_FILE_TYPES = ['image/apng', 'image/jpeg', 'image/pjpeg', 'image/png'];
export const IMAGE_FILE_EXTENSIONS = ['apng', 'png', 'jpeg', 'jpg', 'pjp', 'pjpeg'];
